"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigStatus = void 0;
var ConfigStatus;
(function (ConfigStatus) {
    ConfigStatus["PENDING_APPROVAL"] = "pending_approval";
    ConfigStatus["APPROVED"] = "approved";
    ConfigStatus["DENIED"] = "denied";
})(ConfigStatus || (exports.ConfigStatus = ConfigStatus = {}));
//# sourceMappingURL=enums.js.map